/** Mask shown for sensitive fields on anonymized company previews. */
export const ANONYMIZED_MASK = "XXX";

export function hasAnonymizedFieldValue(value: unknown): boolean {
  if (value == null || value === false || value === "") return false;
  return true;
}

/** System verification field: XXX when value exists on anonymized view, N/A otherwise. */
export function anonymizedVerificationFieldValue(value: unknown, anonymousView: boolean): string {
  if (!hasAnonymizedFieldValue(value)) return "N/A";
  if (anonymousView) return ANONYMIZED_MASK;
  if (typeof value === "boolean") return ANONYMIZED_MASK;
  return String(value);
}

/** Contact person fields: always XXX on anonymized partner view, real value or N/A when unlocked. */
export function anonymizedContactFieldValue(value: unknown, anonymousView: boolean): string {
  if (anonymousView) return ANONYMIZED_MASK;
  if (value == null || value === "") return "N/A";
  return String(value);
}
